import { useDispatch } from "react-redux";
import { show } from "./actions";

export const useToast = () => {
  const dispatch = useDispatch();
  return (...params) => dispatch(show(...params));
};
